import type { Conversation } from "@twilio/conversations";

type MockConversationInput = {
  sid: string;
  friendlyName?: string | null;
  dateUpdated?: Date;
  lastReadMessageIndex?: number | null;
  lastMessage?: { index: number; dateCreated: Date } | null;
  notificationLevel?: any;
};

export function makeMockConversation(
  input: MockConversationInput
): Conversation {
  const base: Partial<Conversation> = {
    sid: input.sid,
    friendlyName: input.friendlyName ?? `Mock ${input.sid}`,
    dateUpdated: input.dateUpdated ?? new Date(),
    lastReadMessageIndex: input.lastReadMessageIndex ?? 0,
    lastMessage: input.lastMessage
      ? ({
          index: input.lastMessage.index,
          dateCreated: input.lastMessage.dateCreated,
        } as any)
      : undefined,
    notificationLevel: input.notificationLevel ?? ("default" as any),

    advanceLastReadMessageIndex: async (index: number) => {
      (input as any).lastReadMessageIndex = index;
      return index;
    },

    updateFriendlyName: async (newName: string) => {
      (base as any).friendlyName = newName;
      (base as any).dateUpdated = new Date();
      return base as Conversation;
    },
  };

  return base as Conversation;
}
